import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ModalPhieuChiNgoaiLe } from "./ModalPhieuChiNgoaiLe";
import { ModalPhieuThuNgoaiLe } from "./ModalPhieuThuNgoaiLe";

export const BtnInPhieuThuChiNgoaiLe = ({ item, inPhieuThu }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      {item.Value > 0 ? (
        <>
          <a href={() => false} onClick={handleShow}>
            <PopoversBootrap
              contentText="In phiếu thu"
              trigger={["hover", "focus"]}
              placement={"top"}
            >
              <img src="/app-assets/images/icon-in-danh-sach.png" />
            </PopoversBootrap>
          </a>{" "}
          {show && (
            <ModalPhieuThuNgoaiLe
              show={show}
              onHide={handleClose}
              id={item.ThuChiID}
              CVType={item.CVType}
              item={item}
              inPhieuThu={inPhieuThu}
            />
          )}
        </>
      ) : (
        <>
          <a href={() => false} onClick={handleShow}>
            <PopoversBootrap
              contentText="In phiếu chi"
              trigger={["hover", "focus"]}
              placement={"top"}
            >
             <img src="/app-assets/images/icon-in-danh-sach.png" />
            </PopoversBootrap>
          </a>
          {show && (
            <ModalPhieuChiNgoaiLe
              show={show}
              onHide={handleClose}
              id={item.ThuChiID}
              hopdongId={item.ChoVayID}
              CVType={item.CVType}
              item={item}
            />
          )}
        </>
      )}
    </>
  );
};
